// Guards de navegação para autenticação
export function setupGuards(router) {
  // Guard para rotas que requerem autenticação
  router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('admin-token')
    const isAdminRoute = to.path.startsWith('/admin')
    const isLoginRoute = to.path === '/admin/login'

    // Se é uma rota administrativa
    if (isAdminRoute) {
      // Se não tem token e não está na página de login
      if (!token && !isLoginRoute) {
        next('/admin/login')
        return
      }

      // Se tem token e está na página de login, redireciona para dashboard
      if (token && isLoginRoute) {
        next('/admin/dashboard')
        return
      }

      // Se tem token, verificar se não expirou
      if (token && !isLoginRoute) {
        try {
          // Verificar se o token tem a estrutura correta (3 segmentos)
          const tokenParts = token.split('.')
          if (tokenParts.length !== 3) {
            localStorage.removeItem('admin-token')
            next('/admin/login')
            return
          }
          
          // Verificar se o payload existe e é válido
          if (!tokenParts[1]) {
            localStorage.removeItem('admin-token')
            next('/admin/login')
            return
          }
          
          const payload = JSON.parse(atob(tokenParts[1]))
          const now = Math.floor(Date.now() / 1000)
          
          if (payload.exp < now) {
            localStorage.removeItem('admin-token')
            next('/admin/login')
            return
          }
        } catch (error) {
          localStorage.removeItem('admin-token')
          next('/admin/login')
          return
        }
      }
    }

    next()
  })
}
